module.exports = __webpack_public_path__ + "images/saaremaa/routes/RMS-ABR-RMS.png";